module.exports = __webpack_public_path__ + "static/media/flip-v-alt.4f558fd8.svg";